<template>
    <b-modal ref="restorebackupmodal" centered lazy title="Restore website" ok-title="Save changes" @shown="loadBackup" @ok="restore()" :hide-header-close="true">
        <div class="prompt-text" v-if="!backup.newBackupMethod">
            Are you sure you want to proceed with this?
        </div>
        <div class="prompt-text" v-if="backup.newBackupMethod">
            Select what do you want to restore?
        </div>
        <div class="prompt-selection" v-if="backup.newBackupMethod">
            <b-form-group>
                <b-form-checkbox-group stacked id="checkboxes1" name="flavour1" v-model="selected" :options="options">
                </b-form-checkbox-group>
            </b-form-group>
        </div>
        <div slot="modal-footer" class="w-100">
            <p class="float-left note">This action cannot be undone.</p>
            <div class="float-right">
                <b-btn variant="flat" @click="close">
                    Not now
                </b-btn>
                <b-btn variant="primary" @click="restore">
                    Restore
                </b-btn>
            </div>

        </div>
    </b-modal>
</template>

<script>
export default {
  name: "restorebackup",
  props: ["backup"],
  data() {
    return {
      selected: [],
      options: [
        {
          text: "Plugins",
          value: "plugins"
        },
        {
          text: "Themes",
          value: "themes"
        },
        {
          text: "Uploads",
          value: "uploads"
        },
        {
          text: "Database",
          value: "db"
        },
        {
          text: "Other (Other folders except uploads in wp-content)",
          value: "others"
        },
        {
          text:
            "More (wp-config, .htaccess and other folders in the WP folder, if you have included any)",
          value: "more"
        },
        {
          text: "Wordpress",
          value: "wp"
        },
        {
          text: "Restore via FTP",
          value: "ftp"
        }
      ]
    };
  },
  methods: {
    close() {
      this.$refs.restorebackupmodal.hide();
    },
    restore() {
      let payload = {};
      payload.action = "restoreBridgeUpload";
      payload.args = {};
      payload.args.siteIDs = [];
      payload.args.siteIDs.push(this.backup.siteID);
      payload.args.params = {
        taskName: this.backup.backupName,
        resultID: this.backup.referenceKey,
        backupFileBasename: ""
      };
      this.$store.dispatch("sendAction", payload);
      this.close();
    },
    loadBackup() {
      

      if (this.backup.newBackupMethod) {
        let payload = {};
        payload.requiredData = {
          getNewBackupDetails: {
            siteId: this.backup.siteID,
            taskName: this.backup.backupName,
            backupID: this.backup.referenceKey,
            backupFileBasename: this.backup.backupFileBasename
          }
        };
        this.$store.dispatch("sendAction", payload).then(response => {
          let getNewBackupDetails = response.data.getNewBackupDetails;
          
          
        });
      }
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modals/RestoreBackup.vue